import { createContext } from 'react';

import { PersonalNumberRangeRow } from 'features/care-connect-settings/hooks/personal-number-range-row';

const PersonalNumberRangeRowContext = createContext<PersonalNumberRangeRow>({} as PersonalNumberRangeRow);

export default PersonalNumberRangeRowContext;
